import { gql } from '@apollo/client';

export const QUERY_USER_PROFILES = gql`
  query UserProfiles {
    userProfiles {
      id
      email
      display_name
      photo_url
      disabled
      plan {
        id
        name
        modules
      }
      available_modules
    }
  }
`;

export const QUERY_USER_PROFILES_PAGE = gql`
  query AdminUserProfiles($limit: Int, $offset: Int, $search: String) {
    userProfiles(limit: $limit, offset: $offset, search: $search) {
      id
      email
      display_name
      photo_url
      disabled
      plan {
        id
        name
        modules
      }
      available_modules
    }
    userProfilesTotal(search: $search)
  }
`;
